// extracted by mini-css-extract-plugin
export var chevronIcon = "_c9-2";
export var teamName = "_c9-1";
export var teamSwitcherButton = "_c9-0";